module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1